/* eslint-disable react/prop-types */
import React from 'react';

import { Container } from './styles';

const Select = ({ items, placeholder, ...props }) => (
  <Container {...props}>
    {!!placeholder && <option value="">{placeholder}</option>}
    {!!items &&
      items?.map(({ id, title, length }) => (
        <option key={id} value={id}>
          {title || length}
        </option>
      ))}
  </Container>
);

export default Select;
